import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

// components
import {
  Box,
  MainHolder,
  StyledText,
  DynamicButton,
  Button,
} from "../../../../components/common";

//svgs
import {
  NewBackButton,
  DoneIconNew,
  EyeIcon,
  FileIcon,
} from "../../../../components/svgs";

// hooks
import { useTheme, useSpinTheWheel } from "../../../../hooks";

// theme

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;

const AirtimeRedemption = () => {
  const history = useHistory();

  const goToHome = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    history.push(`/home?token=${token}`);
  };

  const { itemWon } = useSpinTheWheel();

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [voucher, setVoucher] = useState("");
  const [showVoucher, setShowVoucher] = useState(false);
  const [scratchCardCode, setScratchCardCode] = useState();
  const { themeContext, theme } = useTheme();
  const textRef = useRef(null);

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search);

    const voucher = searchParams.get("voucher");

    setVoucher(voucher);
    // redeemReward({ rewardType: voucher });
  }, []);

  const handleShowVoucher = () => {
    setShowVoucher(!showVoucher);
  };

  const handleCopyClick = () => {
    const textArea = document.createElement("textarea");
    textArea.value = scratchCardCode;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    alert("code copied");
  };

  // useEffect(() => {
  //   if (redemptionData && redemptionData.length) {
  //     const pin = addSpacesToNumber(redemptionData[0].pin);
  //     setScratchCardCode(pin);
  //   }
  // }, [redemptionData]);

  const addSpacesToNumber = (number) => {
    const cleanedNumber = number.replace(/\D/g, "");
    const formattedNumber = cleanedNumber.replace(/(\d{4})(?=\d)/g, "$1 ");
    return formattedNumber;
  };

  return (
    <MainHolder
      style={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
      }}
    >
      <StyledText style={{ fontSize: 25, textAlign: "center" }}>
        You won {itemWon.option}
      </StyledText>

      <ScratchCardContainer>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <StyledText>{itemWon.option}</StyledText>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            border: "1px dashed #7F7F7F",
            borderRadius: 15,
          }}
        >
          <StyledText ref={textRef}>
            {showVoucher ? scratchCardCode : "**** **** **** ****"}
          </StyledText>
          <div
            style={{
              display: "flex",
              backgroundColor: background,
              justifyContent: "center",
              alignItems: "center",
              width: 35,
              height: 26,
              borderRadius: 15,
            }}
            onClick={() => handleCopyClick()}
          >
            <FileIcon />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={handleShowVoucher}
        >
          <EyeIcon isVisible={showVoucher ? true : false} />
          <StyledText style={{ marginLeft: 10 }}>
            {showVoucher ? "Hide voucher code" : "Show voucher code"}
          </StyledText>
        </div>
      </ScratchCardContainer>
      <BottomContent>
        <StyledText style={{ textAlign: "center", fontFamily: "MTNRegular" }}>
          Redeem your airtime voucher by copying the code and recharging with
          <b>*134*PIN#</b> on your phone
        </StyledText>
        <div
          style={{
            width: "100%",
            backgroundColor: "#7F7F7F",
            height: 0.5,
            marginTop: 40,
            marginBottom: 40,
          }}
        />

        <DynamicButton
          label={"Got it"}
          color={background}
          width={"100%"}
          onClick={() => history.push('/spin_the_wheel/history')}
        />
      </BottomContent>

      {/* {showConfirmDialog && <AlertModal voucherName={voucherName} />} */}
    </MainHolder>
  );
};

export default AirtimeRedemption;

const AlertModal = ({
  background,
  success,
  message,
  onClick = () => {},
  voucherName,
}) => {
  const history = useHistory();

  const goToHome = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    history.push(`/home?token=${token}`);
  };

  return (
    <div
      style={{
        position: "absolute",
        zIndex: 100,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.7)",
      }}
    >
      <AlertCurveTop />
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "70%",
          top: "22%",
          padding: "10px",
          textAlign: "center",
          boxSizing: "border-box",
        }}
      >
        <AlertIconContainer>
          <div style={{ width: "68px", height: "68px", borderRadius: "50px" }}>
            <DoneIconNew fill={"#fff"} />
          </div>
        </AlertIconContainer>

        <h1
          style={{
            fontFamily: "MTNBold",
            fontSize: "1.5em",
            marginTop: "40px",
            marginBottom: "50px",
          }}
        >
          Congrats!
        </h1>
        <p style={{ fontFamily: "MTNRegular" }}>
          {`You have selected ${voucherName}. Contact the MTN representative at the Homowo festival for redemtiopn of your prize. TCs apply.`}
        </p>
        <ButtonHolder>
          <Button
            onClick={goToHome}
            style={{
              marginInline: 20,
              marginBlock: 20,
              height: "50px",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              alignSelf: "center",
              display: "flex",
              cursor: "pointer",
            }}
            color={"#E31C79"}
          >
            <StyledText color={"white"}>Great!</StyledText>
          </Button>
        </ButtonHolder>
      </div>
    </div>
  );
};

const PrizeCard = ({ img, prize, description }) => {
  const { themeContext } = useTheme();
  const { activeTheme } = themeContext;

  return (
    <Box
      themeAware={false}
      style={{
        borderRadius: 20,
        backgroundColor: "white",
        shadowColor: activeTheme === "midnight" ? "black" : "#242424",
        shadowOffset: {
          width: 0,
          height: 0,
        },
        shadowOpacity: activeTheme === "midnight" ? 1 : 0.23,
        shadowRadius: 1.62,
        elevation: 4,
        justifyContent: "space-between",
      }}
    >
      <>
        <FastImage
          style={{
            height: 190,
            width: "100%",
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
          }}
          src={img}
        />
        <FastImage
          style={{
            height: "100%",
            width: "100%",
            marginTop: -38,
          }}
          src={`${SERVER_URL}/assets/images/BigCardCurve.png`}
        />
      </>
      <Box
        themeAware={false}
        style={{ alignSelf: "center", backgroundColor: "transparent" }}
      >
        <StyledText align={"center"} margin={0} fontFamily={"medium"} size={26}>
          {description}
        </StyledText>
        <StyledText
          fontFamily={"medium"}
          size={24}
          align={"center"}
          style={{
            textAlign: "center",
            margin: 0,
            paddingBottom: 10,
            paddingLeft: 5,
            paddingRight: 5,
          }}
        >
          {prize}
        </StyledText>
      </Box>
    </Box>
  );
};

const FastImage = styled.img``;

const AlertCurveTop = styled.div`
  position: absolute;
  width: 225%;
  height: 70%;
  top: 30%;
  left: -62%;
  backgroundcolor: "#fff";
  border-top-left-radius: 50%;
  background-color: rgb(255, 255, 255);
  border-top-right-radius: 50%;
`;

const ButtonHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const AlertIconContainer = styled.div`
  margin: 0px auto;
  background-color: #e31c79;
  height: 100px;
  width: 100px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ScratchCardContainer = styled.div`
  width: 80%;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin: 20px;
  padding: 15px;
  overflow: auto;
`;
const BottomContent = styled.div`
  width: 80%;
  background-color: white;
  // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  // border-radius: 8px;
  margin: 20px;
  padding: 15px;
  overflow: auto;
`;
